import api from "@/plugins/api";
import { environmentLabel } from "../../domain/entities/UserListItem";
/**
 * BFF `/environment/all` returns the access manager's environments as `{ label, value }[]`, where
 * the label is the OPUS Reference. It carries no type, so an environment without a Reference shows
 * its id here even where the users list column can show its type.
 */
export class EnvironmentsService {
    async getAll() {
        const response = await api.get("/environment/all", {
            unwrapEnvelope: true,
        });
        return response.data.map((e) => ({ id: e.value, label: environmentLabel({ id: e.value, reference: e.label }) }));
    }
}
